




import {Vue, Component, Prop} from "vue-property-decorator";


@Component({
    components: {
    }
})
export default class Indicator extends Vue {
    @Prop()
    public color!: string;
}
